export const ENVIRONMENT = {
  "ENVIRONMENT": "production",
  "BACKEND_URL": "https://dbia-sporleder.gswebapps.net",
  "FRONTEND_URL": "https://www.sporleder-gaertnerei.de",
  "APP_KEY": "dbia-sporleder-frontend",
  "COMMIT_HASH": "f3ad8fb11bf035049fd31ed31af74140c8bb62de",
  "BC_PROJECTID": "720",
  "BC_APPID": "3478",
  "BC_MEMBER_NUMBER": "220867",
  "BC_MEMBER_MODULES": "app,b2c,database,erp,loyalty,newsletter,payPalCheckout,rechtssicherheit,relaunch,social,voucher,webshop,website,m-220867",
  "GOOGLE_MAPS_KEY": "",
  "CHANNEL_ID": "8",
  "DEFAULT_CULTURE": "de-DE",
  "FIXED_CULTURE": "de-DE",
  "NATIVE_CULTURE": "de-DE",
  "CULTURES": "",
  "LAST_BUILD_TEMPLATE_RUN": "2026-11-05T08:31:32.963Z",
  "LAST_COMMIT_TIMESTAMP": "2026-11-04T10:23:02.000Z",
  "GIT_BRANCH": "main",
  "GIT_REMOTE_URL": "https://github.com/Green-Solutions-Software/CloudSoftwareApps",
  "MENUS": [
    "cs4-menu",
    "cs4-footer",
    "cs4-sidebar",
    "cs4-mobileFooter",
    "cs4-footerCopyright"
  ],
  "ACTIONS": [
    "chainstores",
    "shoppingcart",
    "login",
    "watchlist",
    "dashboard",
    "logout",
    "search"
  ],
  "WITH_CHAINSTORES": true,
  "WITH_APPLINKS": true,
  "FONTS": {
    "arial": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "verdana": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "tahoma": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "trebuchet": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "times-new-roman": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "georgia": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "garamond": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "courier-new": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "brush-script-mt": [
      {
        "weight": "100",
        "style": "normal"
      },
      {
        "weight": "200",
        "style": "normal"
      },
      {
        "weight": "300",
        "style": "normal"
      },
      {
        "weight": "400",
        "style": "normal"
      },
      {
        "weight": "500",
        "style": "normal"
      },
      {
        "weight": "600",
        "style": "normal"
      },
      {
        "weight": "700",
        "style": "normal"
      },
      {
        "weight": "800",
        "style": "normal"
      },
      {
        "weight": "900",
        "style": "normal"
      },
      {
        "weight": "100",
        "style": "italic"
      },
      {
        "weight": "200",
        "style": "italic"
      },
      {
        "weight": "300",
        "style": "italic"
      },
      {
        "weight": "400",
        "style": "italic"
      },
      {
        "weight": "500",
        "style": "italic"
      },
      {
        "weight": "600",
        "style": "italic"
      },
      {
        "weight": "700",
        "style": "italic"
      },
      {
        "weight": "800",
        "style": "italic"
      },
      {
        "weight": "900",
        "style": "italic"
      }
    ],
    "open-sans": [
      {
        "weight": "",
        "style": ""
      }
    ],
    "montserrat": [
      {
        "weight": "",
        "style": ""
      }
    ],
    "cormorant": [
      {
        "weight": "",
        "style": ""
      }
    ],
    "source-sans-3": [
      {
        "weight": "",
        "style": ""
      }
    ]
  },
  "FONTS_NON_WOFF2": []
};
